import { Outlet, Navigate } from "react-router-dom";
import { useAuth } from "@/hooks";
import { AdminSidebar } from "@/components/admin/AdminSidebar";
import { AdminHeader } from "@/components/admin/AdminHeader";
import { Skeleton } from "@/components/ui/skeleton";
import { useState } from "react";

export function AdminLayout() {
  const { user, isAdmin, loading } = useAuth();
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="space-y-4 w-64">
          <Skeleton className="h-8 w-full" />
          <Skeleton className="h-32 w-full" />
          <Skeleton className="h-8 w-3/4" />
        </div>
      </div>
    );
  }

  if (!user || !isAdmin) {
    return <Navigate to="/admin/login" replace />;
  }



return (
    <div className="min-h-screen bg-gray-50 flex">
      {/* 1. On passe l'état et le mutateur à la barre latérale */}
      <AdminSidebar isCollapsed={isSidebarCollapsed} setIsCollapsed={setIsSidebarCollapsed} />
      
      {/* 2. On change dynamiquement ml-64 (déplié, 256px) en ml-20 (replié, 80px) */}
      <div 
        className={`flex-1 flex flex-col transition-all duration-200 ${
          isSidebarCollapsed ? "ml-0 lg:ml-20" : "ml-0 lg:ml-64"
        }`}
      >
        <AdminHeader />
        <main className="flex-1 p-6 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );

}
